import { render, staticRenderFns } from "./WareneinkaufGesamtPieChart.vue?vue&type=template&id=31988e58&"
import script from "./WareneinkaufGesamtPieChart.vue?vue&type=script&lang=ts&"
export * from "./WareneinkaufGesamtPieChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports